import { render, staticRenderFns } from "./DriversTransfers.vue?vue&type=template&id=61d58f3c&scoped=true"
import script from "./DriversTransfers.vue?vue&type=script&lang=js"
export * from "./DriversTransfers.vue?vue&type=script&lang=js"
import style0 from "./DriversTransfers.vue?vue&type=style&index=0&id=61d58f3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d58f3c",
  null
  
)

export default component.exports